import React from "react";

import { DriversWidget } from "../../Drivers";
import { OrdersWidget } from "../../Orders";
import { ScheduleWidget } from "../../Schedules";
import { DumpYardsWidget } from "../../DumpYards";
import { ReceivedOrdersWidget } from "../../ReceivedOrders";
import { ReportsWidget, InventoryWidget } from "../components";

import "./AdminDashboard.scss";

export function AdminDashboard() {
  return (
    <div className="admin-dashboard-component">
      <ReceivedOrdersWidget />
      <DriversWidget />
      <OrdersWidget />
      <ScheduleWidget />
      <DumpYardsWidget />
      <ReportsWidget />
      <InventoryWidget />
    </div>
  );
}
